module.exports = __webpack_public_path__ + "img/336.d88d42bc.png";